(() => {
  const SELECTOR = ".cart-drawer-recommendations .swiper";

  function initCartDrawerSlider() {
    document.querySelectorAll(SELECTOR).forEach((slider) => {
      if (!window.FoxTheme || !FoxTheme.Carousel) return;

      if (slider.dataset.customSliderInitialized === "true") return;

      const carousel = new FoxTheme.Carousel(slider, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        loop: false,

      });

      carousel.init();

      slider.dataset.customSliderInitialized = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", initCartDrawerSlider);

  document.addEventListener("cart:updated", () => {
    setTimeout(initCartDrawerSlider, 50);
  });

  const observer = new MutationObserver(() => {
    initCartDrawerSlider();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();